import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { Row, Col, Card, Table } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import Preloader from "../../Components/Preloader";
import LeafletMap from "../../Components/LeafletMap";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import swal from "sweetalert2";
import { getTrackDetailsBookingList } from "../../redux/actions/BookingActions";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import "leaflet/dist/leaflet.css";
import LeafletMapHistoryVehicle from "../../Components/LeafletMapHistoryVehicle";
import { getDateTimeMysqlFormatYm, getDisplayDateTimeFormat, getCurrentTimeMysql, getTimeDisplay } from "../../util/generalUtills";
import { docUrl } from "../../axios";

const TimelineStyles = styled.div`
  .booking-log-timeline {
    position: relative;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 23px 16px 23px 12px;
  }
  .booking-log-timeline .timeline-track {
    position: absolute;
    left: 23px;
    top: 23px;
    bottom: 23px;
    width: 2px;
    background: #adb5bd;
    border-radius: 1px;
    z-index: 0;
  }
  .booking-log-timeline .timeline-row {
    display: flex;
    align-items: flex-start;
    position: relative;
    z-index: 1;
    margin-bottom: 20px;
  }
  .booking-log-timeline .timeline-row:last-child {
    margin-bottom: 0;
  }
  .booking-log-timeline .timeline-badge {
    width: 46px;
    min-width: 46px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    flex-shrink: 0;
    border-radius: 50%;
    color: #fff;
    white-space: nowrap;
    box-sizing: border-box;
    font-family: inherit;
    text-transform: uppercase;
  }
  .booking-log-timeline .timeline-badge.timeline-badge--app {
    background-color: #f0ad4e !important;
    color: #fff !important;
  }
  .booking-log-timeline .timeline-badge.timeline-badge--sys {
    background-color: #5bc0de !important;
    color: #fff !important;
  }
  .booking-log-timeline .timeline-badge.timeline-badge--web {
    background-color: #5cb85c !important;
    color: #fff !important;
  }
  .booking-log-timeline .timeline-badge.timeline-badge--other {
    background-color: #6c757d !important;
    color: #fff !important;
  }
  .booking-log-timeline .timeline-body {
    margin-left: 14px;
    flex: 1;
    min-width: 0;
  }
  .booking-log-timeline .timeline-body .timeline-title {
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 4px;
    color: #212529;
  }
  .booking-log-timeline .timeline-body .timeline-desc {
    font-size: 0.9rem;
    color: #495057;
    margin-bottom: 2px;
    line-height: 1.4;
  }
  .booking-log-timeline .timeline-body .timeline-time {
    font-size: 0.8rem;
    color: #6c757d;
  }
`;

const Dashboard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams();
  const [formData, setFormData] = useState({})
  const [videoUrl, setVideoUrl] = useState(null)
  const defaultCenter = { lat: 26.9124, lng: 75.7873 };
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    bookingReducer: {
      trackDetailsBookingList,
      changedBookingStatus,
      loadingBooking,
      errorsBooking,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (auth?.accessToken && id) {
      dispatch(getTrackDetailsBookingList(auth?.accessToken, id));
    }
  }, [auth?.accessToken, id]);

  useEffect(() => {
    const bookingDate =
  
      trackDetailsBookingList?.data?.bookingDate ||
      trackDetailsBookingList?.bookingLog?.booking?.bookingDate ||
      "";
    const fileId =
      trackDetailsBookingList?.data?.fileId ||
      
      "";

    const formattedDate = getDateTimeMysqlFormatYm(bookingDate) || "";

    if (!formattedDate || !fileId) {
      setVideoUrl(null);
      return;
    }

    setVideoUrl(`${docUrl}/${formattedDate}/video/trip_end_${fileId}.mp4`);
  }, [trackDetailsBookingList]);

  useEffect(() => {
    if (errors) {
      if (errors?.status === 401) {
        dispatch(logout());
        toast.error(errors?.data?.message);
        window.location.reload();
      }
    }
  }, [errors])


  useEffect(() => {
    if (errorsBooking?.status === 409) {
      swal.fire({
        show: true,
        title: "Oops!",
        text: errorsBooking?.data?.message,
        icon: "error",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_STATUS' });
    }
    else if (errorsBooking?.status === 400) {
      dispatch({ type: 'RESET_DELETE_STATUS' });
    }
  }, [errorsBooking])


  useEffect(() => {
    if (changedBookingStatus.success) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedBookingStatus.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_STATUS' });
      navigate(-1);
    }
  }, [changedBookingStatus])


  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_BOOKING_STATUS' });
  }, [dispatch]);

  // statuses item se mode infer karo (API me mode nahi aata)
  const inferModeFromStatus = (status, remark) => {
    const s = (status || "").toUpperCase();
    const r = (remark || "").toLowerCase();
    if (s === "OPEN VALVE" && (r.includes("automatically by system") || r.includes("by system"))) return "Sys";
    if (s === "CLOSE VALVE" && (r.includes("mqtt") || r.includes("telemetry"))) return "Sys";
    if (s === "DRIVER_ASSIGNED" || (r.includes("slip generation") || r.includes("slip created"))) return "Web";
    return "App";
  };

  // Pehle bookingLog.statuses (naya API), phir bookingLogs array, phir single bookingLog
  const bookingLogs = (() => {
    const statuses = trackDetailsBookingList?.bookingLog?.statuses;
    if (Array.isArray(statuses) && statuses.length > 0) {
      return statuses.map((s) => ({
        id: s.id,
        status: s.status,
        remark: s.remark,
        createdAt: s.createdAt,
        updatedAt: s.updatedAt,
        mode: inferModeFromStatus(s.status, s.remark),
      }));
    }
    const logsArray = trackDetailsBookingList?.bookingLogs;
    if (Array.isArray(logsArray) && logsArray.length > 0) return [...logsArray];
    const single = trackDetailsBookingList?.bookingLog;
    if (single) return [single];
    return [];
  })();

  // newest pehle (createdAt desc) - reverse chronological
  const sortedLogs = [...bookingLogs].sort((a, b) => new Date(b?.createdAt || 0) - new Date(a?.createdAt || 0));

  const getModeBadgeClass = (mode) => {
    if (!mode) return "timeline-badge--other";
    const m = String(mode).toLowerCase();
    if (m === "app") return "timeline-badge--app";
    if (m === "sys") return "timeline-badge--sys";
    if (m === "web") return "timeline-badge--web";
    return "timeline-badge--other";
  };

  const getModeLabel = (mode) => {
    const m = String(mode || "").toLowerCase();
    if (m === "app") return "App";
    if (m === "sys") return "Sys";
    if (m === "web") return "Web";
    return mode || "—";
  };

  const TimelineEventItem = ({ log }) => (
    <div className="timeline-row">
      <div className={`timeline-badge ${getModeBadgeClass(log?.mode)}`}>
        {getModeLabel(log?.mode)}
      </div>
      <div className="timeline-body">
        <div className="timeline-title">{log?.status ?? "—"}</div>
        <div className="timeline-desc">{log?.remark || "—"}</div>
        <div className="timeline-time">{getDisplayDateTimeFormat(log?.createdAt)}</div>
      </div>
    </div>
  );


  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Booking"), path: "Add-Booking" },
          { label: t("Track Booking Details"), path: "/Track-Details-Booking/:id", active: true },
        ]}
        title={t("Track Booking Details")}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title as="h4" style={{ marginBottom: '-14px', marginTop: '6px' }}>Customer Details</Card.Title>
            </Card.Header>
            <hr className="my-2" />
            <Card.Body style={{ marginTop: '-12px' }}>
              <div className="row">
                <div className="col-lg-2">
                  Name: {trackDetailsBookingList?.bookingLog?.booking?.name}
                </div>

                <div className="col-lg-4">
                  Source: {trackDetailsBookingList?.bookingLog?.booking?.hydrantName}
                </div>

                <div className="col-lg-4">
                  Destination: {trackDetailsBookingList?.bookingLog?.booking?.destinationName}
                </div>

                <div className="col-lg-2">
                  Pickup Time: {getCurrentTimeMysql(trackDetailsBookingList?.bookingLog?.booking?.bookingDate)}
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col lg={6}>


          <Card>
            <Card.Header>
              <Card.Title as="h4" style={{ marginBottom: '-14px', marginTop: '6px' }}>Filled tanker at Hydrant</Card.Title>
            </Card.Header>
            <hr className="my-2" />
            <Card.Body style={{ marginTop: '-12px' }}>
              <div className="mt-4">
                <img
                  style={{ width: '100%', height: '450px' }}
                  src={`${docUrl}/${getDateTimeMysqlFormatYm(
                    trackDetailsBookingList?.data?.booking_date ||
                    trackDetailsBookingList?.data?.bookingDate
                  )}/open_valve/hydrant_open_valve_${trackDetailsBookingList?.data?.fileId}.png`}
                  alt="Filled tanker at hydrant"
                />
              </div>
              {(trackDetailsBookingList?.bookingLog?.booking?.identifiedPlate ||
                trackDetailsBookingList?.bookingLog?.booking?.numberPlateFile) && (
                <div className="mt-3">
                  <strong>{t("Captured Number Plate")}</strong>
                  <div className="mt-2 d-flex align-items-center flex-wrap gap-2">
                    {trackDetailsBookingList?.bookingLog?.booking?.numberPlateFile && (
                      <img
                        style={{ maxHeight: '90px', maxWidth: '220px', border: '1px solid #dee2e6', borderRadius: '4px' }}
                        src={`${docUrl}/${getDateTimeMysqlFormatYm(
                          trackDetailsBookingList?.data?.booking_date ||
                          trackDetailsBookingList?.data?.bookingDate
                        )}/open_valve/number_plate/${trackDetailsBookingList.bookingLog.booking.numberPlateFile}`}
                        alt="Captured number plate"
                      />
                    )}
                    {trackDetailsBookingList?.bookingLog?.booking?.identifiedPlate && (
                      <span>
                        {trackDetailsBookingList.bookingLog.booking.identifiedPlate}
                        {trackDetailsBookingList.bookingLog.booking.plateMatched !== null &&
                          trackDetailsBookingList.bookingLog.booking.plateMatched !== undefined && (
                            <span
                              className={`badge ms-2 ${trackDetailsBookingList.bookingLog.booking.plateMatched ? "bg-success" : "bg-danger"
                                }`}
                            >
                              {trackDetailsBookingList.bookingLog.booking.plateMatched ? t("Matched") : t("Not Matched")}
                            </span>
                          )}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
          {(loadingBooking === false && videoUrl != null) && (<>
            <Card>
              <Card.Header>
                <Card.Title as="h4" style={{ marginBottom: '-14px', marginTop: '6px' }}>Trip End Video</Card.Title>
              </Card.Header>
              <hr className="my-2" />
              <Card.Body style={{ marginTop: '-12px' }}>
                <div className="mt-4">
                  <video
                    style={{ width: '100%', height: '450px' }}
                    controls
                    preload="auto"
                  >
                    <source
                      src={videoUrl}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </Card.Body>
            </Card>
          </>)}

        </Col>

        <Col lg={6}>
          <TimelineStyles>
          <Card>
            <Card.Header>
              <Card.Title as="h4" style={{ marginBottom: '-14px', marginTop: '6px' }}>Booking Status</Card.Title>
            </Card.Header>
            <hr className="my-2" />
            <Card.Body>
                <div className="booking-log-timeline mb-4">
                  {sortedLogs.length === 0 ? (
                    <p className="text-muted mb-0">No booking log yet.</p>
                  ) : (
                    <>
                      <div className="timeline-track" aria-hidden="true" />
                      {sortedLogs.map((log, index) => (
                        <TimelineEventItem
                          key={log?.id ?? log?.externalId ?? index}
                          log={log}
                        />
                      ))}
                    </>
                  )}
                </div>

                {/* Booking details table - commented out
                <div className="booking-details-section-title">Booking details</div>
                <div className="table-responsive">
                  <Table size="sm" className="mb-0" bordered style={{ border: '1px solid #dee2e6' }}>
                    <tbody>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Booking ID</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.data?.bookingid ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Hydrant Name</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.bookingLog?.booking?.hydrantName ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Destination Name</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.bookingLog?.booking?.destinationName ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Driver Name</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.bookingLog?.booking?.driverName ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Driver Mobile</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.bookingLog?.booking?.driverMobile ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Driver Vehicle Number</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.bookingLog?.booking?.vehicleNumber ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Driver Vehicle Type</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.bookingLog?.booking?.vehicleType ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Distance (km)</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.bookingLog?.booking?.totalDistance ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Filling Volume (K.L.)</td><td style={{ border: '1px solid #dee2e6' }}>{trackDetailsBookingList?.bookingLog?.booking?.fillingVolume ?? "-"}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Start Time</td><td style={{ border: '1px solid #dee2e6' }}>{getTimeDisplay(trackDetailsBookingList?.bookingLog?.booking?.startTime)}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>End Time</td><td style={{ border: '1px solid #dee2e6' }}>{getTimeDisplay(trackDetailsBookingList?.bookingLog?.booking?.endTime)}</td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>AEN Approval</td><td style={{ border: '1px solid #dee2e6' }}><span className={(trackDetailsBookingList?.bookingLog?.booking?.aenApprovalStatus)}>{trackDetailsBookingList?.bookingLog?.booking?.aenApprovalStatus ?? "-"}</span></td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>JEN Approval</td><td style={{ border: '1px solid #dee2e6' }}><span className={(trackDetailsBookingList?.bookingLog?.booking?.jenApprovalStatus)}>{trackDetailsBookingList?.bookingLog?.booking?.jenApprovalStatus ?? "-"}</span></td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Sarpanch Approval</td><td style={{ border: '1px solid #dee2e6' }}><span className={(trackDetailsBookingList?.bookingLog?.booking?.sarpanchApprovalStatus)}>{trackDetailsBookingList?.bookingLog?.booking?.sarpanchApprovalStatus ?? "-"}</span></td></tr>
                      <tr><td style={{ border: '1px solid #dee2e6' }}>Block Approval</td><td style={{ border: '1px solid #dee2e6' }}><span className={(trackDetailsBookingList?.bookingLog?.booking?.blockApprovalStatus)}>{trackDetailsBookingList?.bookingLog?.booking?.blockApprovalStatus ?? "-"}</span></td></tr>
                    </tbody>
                  </Table>
                </div>
                */}
            </Card.Body>
          </Card>
          </TimelineStyles>
        </Col>
      </Row>
      {trackDetailsBookingList?.gpsData?.length > 0 && (
        <>
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Header>
                  <Card.Title as="h4" style={{ marginBottom: '-14px', marginTop: '6px' }}>Travel upto Hydrant</Card.Title>
                </Card.Header>
                <hr className="my-2" />
                <Card.Body>
                  <div style={{ position: "relative", overflow: "hidden", height: "400px" }}>
                    <LeafletMapHistoryVehicle
                      mapHeight={"400px"}
                      routeData={trackDetailsBookingList?.gpsData}
                      isMarkerShow={false}
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </>
      )}

      {loadingBooking && (<Preloader />)}
    </>
  );
};

export default Dashboard;
